import { render, staticRenderFns } from "./pay-detail.vue?vue&type=template&id=2cda2256&scoped=true&"
import script from "./pay-detail.vue?vue&type=script&lang=js&"
export * from "./pay-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cda2256",
  null
  
)

export default component.exports